import { twMerge } from "tailwind-merge";
import { ForwardedRef } from "react";
import { PropsWithAs } from "../types";
import { forwardRefWithGeneric } from "../utils";

export type GridItemSize = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

export interface GridItemProps {
  xs?: GridItemSize;
  sm?: GridItemSize;
  md?: GridItemSize;
  lg?: GridItemSize;
  xl?: GridItemSize;
}

const GridItem = <T extends React.ElementType = "div">(
  { as, ...props }: PropsWithAs<GridItemProps, T>,
  ref: ForwardedRef<any>
) => {
  const {
    className,
    xs = 1,
    sm = xs,
    md = sm,
    lg = md,
    xl = lg,
    ...rest
  } = props;
  const Component = as ?? "div";

  return (
    <Component
      {...rest}
      ref={ref}
      className={twMerge(
        `col-span-${xs}`,
        sm !== xs ? `sm:col-span-${sm}` : undefined,
        md !== sm ? `md:col-span-${md}` : undefined,
        lg !== md ? `lg:col-span-${lg}` : undefined,
        xl !== lg ? `xl:col-span-${xl}` : undefined,
        className
      )}
    />
  );
};

export default forwardRefWithGeneric(GridItem);
